export default "__VITE_ASSET__CQONAbXp__"